import { RootState } from 'store';

export const filtersSelector = (state: RootState) =>
  state.map_v2.tabs.layers.state.filters;

export const temporaryEntitiesSelector = (state: RootState) =>
  state.map_v2.tabs.layers.state.temporaryEntities;

export const sharedEntityIdSelector = (state: RootState) =>
  state.map_v2.tabs.layers.state.sharedEntityId;

export const isMapDataLoadedSelector = (state: RootState) =>
  state.map_v2.tabs.layers.state.isMapDataLoaded;

export const mapDndStateSelector = (state: RootState) =>
  state.map_v2.tabs.layers.state.mapDndState;

export const histogramSelector = (state: RootState) =>
  state.map_v2.tabs.layers.state.histogram;

export const timelineTypesSelector = (state: RootState) =>
  state.map_v2.tabs.layers.state.timelineTypes;

export const imageryTimelineStateSelector = (state: RootState) =>
  state.map_v2.tabs.layers.state.imageryTimelineState;
